import { MobileUserSettings } from '../../models';
import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'personal-info-view',
    styles: [require('./personal-info-view.component.scss')],
    template: require('./personal-info-view.component.pug')
})
export class PersonalInfoViewComponent{
    @Input() settings: MobileUserSettings;

    constructor() { }

    get email() {
        return this.settings.email;
    }

    get phoneNumber() {
        return this.settings.phoneNumber;
    }

    get smsProviderName() {
        return this.settings.smsProviders.selected.name;
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/settings/shared/ui/personal-info-view/personal-info-view.component.ts